/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLocationsFromExcelSheetResult } from '../../models/create-locations-from-excel-sheet-result';

export interface ApiLocationBulkUploadPost$Params {
      body?: {
'ExcelFile'?: Blob;
'DistrictId'?: string;
}
}

export function apiLocationBulkUploadPost(http: HttpClient, rootUrl: string, params?: ApiLocationBulkUploadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationsFromExcelSheetResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationBulkUploadPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateLocationsFromExcelSheetResult>;
    })
  );
}

apiLocationBulkUploadPost.PATH = '/api/Location/bulk-upload';
